export const BUSINESS_TYPES: Array<string> = ['Tire Dealer', 'New/Used Car Dealer', 'Equipment Jobber', 'Supply Jobber','Fleet/Commercial','Government Military'
,'Government Federal','Government State', 'Indian Reservation', 'Dept of Transportation','Charity','Leasing Company','International','Farmer','OEM Manufacturer'];

export const FILE_SIZE_LIMIT: number = 5242880;

export const FILE_FORMATS_ALLOWED : Array<string> = ['image/jpeg','image/png','image/tiff','image/bmp','application/pdf','application/msword','application/vnd.openxmlformats-officedocument.wordprocessingml.document','text/csv','application/vnd.ms-excel','application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];

export const FILE_SIZE_ERROR : string = `File size exceeds the limit (5 MB)`;

export const FILE_LIMIT_ERROR : string = `Multiple files not allowed`;

export const FILE_FORMAT_ERROR : string = `Please upload JPEG/PNG/TIFF/BMP/PDF/DOC/DOCX/CSV/XLS/XLSX`;

export const FILE_COUNT_ERROR = `No more than 4 files allowed`;
